module.exports = __webpack_public_path__ + "media/promo/courses/images/reload2-763a6b4b37272f5ce4bff21477ab4089.png";